import { render, staticRenderFns } from "./KPIMoreScore.vue?vue&type=template&id=6dd9c161&scoped=true&"
import script from "./KPIMoreScore.vue?vue&type=script&lang=js&"
export * from "./KPIMoreScore.vue?vue&type=script&lang=js&"
import style0 from "./KPIMoreScore.vue?vue&type=style&index=0&id=6dd9c161&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd9c161",
  null
  
)

export default component.exports